import {useMutation} from "@tanstack/react-query";
import {openExpedientCustomerOfferMutationOptions} from "./open-expedient-customer-offer.mutation-options";

export function useOpenExpedientCustomerOffer(id: string) {
  return useMutation(openExpedientCustomerOfferMutationOptions(id));
}
